import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Panel, Button } from 'react-bootstrap';
import Title from '../../common/page-title/index';
import FileTable from './csv-table';
import UploadHistory from './upload-history';
import { deleteImportableFiles, getDataImportIndex, importFiles } from '../../../actions/data-import';

import './data-import.css';

class DataImport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checkedList: [],
        };
        this.handleListChange = this.handleListChange.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(getDataImportIndex());
    }

    handleListChange(filename, type) {
        let list = this.state.checkedList;

        switch (type) {
            case 'add': {
                list.push(filename);
                break;
            }
            case 'remove': {
                list = list.filter(item => {
                    return item !== filename;
                });

                break;
            }
            default:
                break;
        }

        this.setState({checkedList: list});
    }

    handleImport() {
        const list = this.state.checkedList;
        this.setState({
            checkedList: [],
        });


        this.props.dispatch(importFiles(list));
    }

    handleDelete() {
        this.props.dispatch(deleteImportableFiles(this.state.checkedList));
    }


    renderFooter() {
        return (
            <div className="fluid text-right">
                <Button className="btn red-ghost-btn mg-lr-10 text-uppercase"
                        onClick={event => this.handleImport(event)}>Import</Button>
                <Button className="btn red-ghost-btn mg-lr-10 text-uppercase"
                        onClick={event => this.handleDelete(event)}>Delete</Button>
            </div>
        );
    }

    render() {
        return (

              <div className="container-fluid">

                  <Title>Data Import</Title>

                  <Panel footer={this.renderFooter()}>
                      {this.props.fetched ?
                          <FileTable data={this.props.files} handleListChange={this.handleListChange}/> :
                          <div>Loading...</div>}
                  </Panel>
                  <h3>Upload History</h3>
                  {this.props.fetched ? this.props.history === [] ?
                      <Panel>No import history in past 30 days.</Panel> :
                      <UploadHistory data={this.props.history}/> : <Panel>Loading...</Panel>}
              </div>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        files: state.data_imports.files,
        history: state.data_imports.history,
        fetched: state.data_imports.fetched
    }
}

export default connect(mapStateToProps)(DataImport)



// WEBPACK FOOTER //
// ./src/components/admin/data-import/index.jsx